// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"e81fc908","142":"fc71e45d","438":"50c97119","538":"3dfd92e9","561":"cd1717dd","648":"fa986352","668":"a0752c46"}[chunkId] + ".chunk.js";
};